import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { GuidaLabel } from '@inter-ikea-guida/framework';
import { SkapaOption, SkapaSelect } from '@inter-ikea-guida/skapa';
import { useIsMetricMeasures } from '../../hooks/useIsMetricMeasures';
import { getFormState } from '../../store/app/selectors';
import { getTranslation } from '../../store/i18n/selectors';
import { OPTION_TYPE_MEASUREMENT, SELECT } from '../../utils';
import { getWidths, useUpdatedWallValues } from '../../views/viewUtils';
import { FormattedMeasurement } from '../common/FormattedMeasurement';
import { StyledSelect } from './styles';
export const CornerWallFormSelect = ({ id, options, value, onValueChange, labelText, dataTestId }) => {
    const translate = useSelector(getTranslation);
    const formState = useSelector(getFormState);
    const useMetricsMeasures = useIsMetricMeasures();
    const { leftWidth, rightWidth } = getWidths(formState);
    const { wallOneValues, wallTwoValues } = useUpdatedWallValues(formState.size_depth_left, formState.size_depth_right, leftWidth, rightWidth);
    const isOptionDisabled = (option, id) => {
        if (id === 'size_width_left_85' || id === 'size_width_left_88') {
            return !wallOneValues.includes(Number(option));
        }
        if (id === 'size_width_right_85' || id === 'size_width_right_88') {
            return !wallTwoValues.includes(Number(option));
        }
        return false;
    };
    return (_jsx(_Fragment, { children: _jsx(StyledSelect, { children: _jsx(SkapaSelect, { id: id, dataTestId: dataTestId, onChange: e => {
                    const index = options.findIndex(option => option.value === e.target.value);
                    onValueChange(id, e.target.value, SELECT, index);
                }, value: value, hintText: '', label: _jsx(GuidaLabel, { text: labelText }), ariaLabel: labelText, children: options.map((option, index) => (_jsx(SkapaOption, { value: option.value, name: option.type === OPTION_TYPE_MEASUREMENT ? (_jsx(FormattedMeasurement, { cm: parseInt(option.value, 10), toInches: !useMetricsMeasures, withDoublePrime: true })) : (translate(option.label)), disabled: isOptionDisabled(option.value, id) }, index))) }) }) }));
};
//# sourceMappingURL=CornerWallFormSelect.js.map